import React from 'react';
import CalculateMaximumMortgageForm from '~/components/Tools/CalculateMaximumMortgage/CalculateMaximumMortgageForm';
import Layout from '~/components/Tools/ToolLayout';
import { useBodyClass } from '~/hooks/useBodyClass';
import { CalculateMaximumMortgageCalculationProvider } from '~/pages/Tools/CalculateMaximumMortgage/Calculate/context/CalculationContext';
import { CalculateMaximumMortgageFormProvider } from '~/pages/Tools/CalculateMaximumMortgage/Calculate/context/FormProvider';
import { CalculateMaximumMortgageTabsProvider } from '~/pages/Tools/CalculateMaximumMortgage/Calculate/context/TabsContext';
import { MortgagePeriod, MortgageType } from '~/types/Calculations';
import { OfficeDetails } from '~/types/Office';

export type CalculateMaximumMortgageCalculateProps = {
  income?: number;
  age?: number;
  totalOffices: number;
  totalReviews: number;
  office?: OfficeDetails;
  defaultPeriod: MortgagePeriod;
  periods: MortgagePeriod[];
  defaultType: MortgageType;
  types: MortgageType[];
  nhgEnabled: boolean;
  energyLabelsEnabled: boolean;
};

export const CalculateMaximumMortgageCalculate: React.FC<
  CalculateMaximumMortgageCalculateProps
> = ({
  income,
  age,
  totalOffices,
  totalReviews,
  office,
  defaultPeriod,
  defaultType,
  types,
  periods,
  nhgEnabled,
  energyLabelsEnabled,
}) => {
  useBodyClass('bg-blue-10');

  return (
    <Layout title="Maximale hypotheek berekenen" poweredBy={['vitec', 'moneyview']}>
      <CalculateMaximumMortgageFormProvider
        defaultIncome={income}
        defaultAge={age}
        defaultPeriod={defaultPeriod}
        defaultType={defaultType}
      >
        <CalculateMaximumMortgageCalculationProvider
          defaultIncome={income}
          defaultAge={age}
          defaultPeriod={defaultPeriod}
          defaultType={defaultType}
          types={types}
          periods={periods}
          officeId={office?.id}
          nhgEnabled={nhgEnabled}
          energyLabelsEnabled={energyLabelsEnabled}
        >
          <CalculateMaximumMortgageTabsProvider>
            <CalculateMaximumMortgageForm
              office={office}
              totalOffices={totalOffices}
              totalReviews={totalReviews}
            />
          </CalculateMaximumMortgageTabsProvider>
        </CalculateMaximumMortgageCalculationProvider>
      </CalculateMaximumMortgageFormProvider>
    </Layout>
  );
};
